import * as actionType from "./Action_Type";
import { CALL_API } from "../Middlewares/api";
import { CHANGE_PASSWORD } from "../Utils/Strings/Service_Endpoint";
import * as SGUri from "../Utils/PagesSwitch.js";

export const openLoginDialog = () => {
    return dispatch => {
        dispatch({type : actionType.AUTHENTICATION_OPEN_LOGIN_DIALOG});
    }
}

export const closeLoginDialog = () => {
    return dispatch =>{
        dispatch({type : actionType.AUTHENTICATION_CLOSE_LOGIN_DIALOG});
    }
}


// WEBPACK FOOTER //
// ./src/Actions/Action_ServiceRequest_Index.js